module.exports = __webpack_public_path__ + "./img/logo.2711de42a1cc28e308fe5265bc565fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/logo.png
// module id = ./src/assets/brand/logo.png
// module chunks = 0